import { Capacitor } from "@capacitor/core";
import { useMutation } from "@tanstack/react-query";

import { useBrowser } from "@react/ionic/browser";

import { API } from "../../../bootstrap/api.ts";
import { AUTH_CALLBACK_URL } from "../lib/auth-callback-url.ts";
import { authSessionStore } from "../state/auth-session.ts";

interface AuthRedirectResult {
  readonly isPending: boolean;
  readonly redirect: () => void;
}

export function useAuthRedirect(): AuthRedirectResult {
  const browser = useBrowser();

  const getAuthRedirectUrl = useMutation({
    mutationFn: async ({ session }: { readonly session: string }) => {
      const isNative = Capacitor.isNativePlatform();
      const returnUrl = isNative
        ? AUTH_CALLBACK_URL.mobile
        : `${window.location.origin}${AUTH_CALLBACK_URL.web}`;

      return API.auth.getAuthRedirectUrl({ returnUrl, session });
    },
  });

  return {
    isPending: getAuthRedirectUrl.isPending,
    redirect: () => {
      const session = authSessionStore.startSession();

      getAuthRedirectUrl.mutate(
        { session },
        {
          onSuccess: ({ redirectUrl }) => {
            const isNative = Capacitor.isNativePlatform();

            if (isNative) {
              browser.open.mutate({ url: redirectUrl });
            } else {
              window.location.href = redirectUrl;
            }
          },
        },
      );
    },
  };
}
